// src/services/ativosService.js
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  getDocs,
  getDoc,
  onSnapshot,
  query,
  where,
  orderBy,
  serverTimestamp,
  limit,
} from 'firebase/firestore';

import { db } from './firebase';

/* =========================================================
   ATIVOS SERVICE
   - CRUD/listen de ativos de troca (carro, terreno, imóvel, dinheiro, etc.)
   - Coleção: ativos
========================================================= */

export async function criarAtivo(payload) {
  if (!payload) throw new Error('payload ausente');

  const corretorId = payload.corretorId || payload.uid || payload.ownerId;
  if (!corretorId) throw new Error('corretorId é obrigatório no ativo.');

  const docPayload = {
    ...payload,
    corretorId,
    status: payload.status || 'ativo', // ativo | inativo | vendido | reservado
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  const ref = await addDoc(collection(db, 'ativos'), docPayload);
  return ref.id;
}

export async function atualizarAtivo(id, payload) {
  if (!id) throw new Error('id do ativo é obrigatório');
  if (!payload) throw new Error('payload ausente');

  const ref = doc(db, 'ativos', id);
  await updateDoc(ref, {
    ...payload,
    updatedAt: serverTimestamp(),
  });

  return { ok: true };
}

export async function getAtivoById(id) {
  if (!id) return null;
  const snap = await getDoc(doc(db, 'ativos', id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function listarAtivosDoCorretor(
  uid,
  { somenteAtivos = true } = {}
) {
  if (!uid) return [];

  const constraints = [
    where('corretorId', '==', uid),
    orderBy('updatedAt', 'desc'),
    limit(200),
  ];

  if (somenteAtivos) {
    constraints.unshift(where('status', '==', 'ativo'));
  }

  const q = query(collection(db, 'ativos'), ...constraints);
  const snap = await getDocs(q);

  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export function listenAtivosDoCorretor(uid, cb, { somenteAtivos = true } = {}) {
  if (!uid) return () => {};

  const constraints = [
    where('corretorId', '==', uid),
    orderBy('updatedAt', 'desc'),
    limit(200),
  ];

  if (somenteAtivos) {
    constraints.unshift(where('status', '==', 'ativo'));
  }

  const q = query(collection(db, 'ativos'), ...constraints);

  return onSnapshot(q, (snap) => {
    const lista = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    cb(lista);
  });
}
